import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { Container, Col, Row, Button, Form, Card } from "react-bootstrap";

import "./Login.css";
import { isLoggedIn, login } from "../../../utils/BeeApi";
import { get } from "../../../utils/DeApi";
import { setToken } from "../../../utils/AuthService";
import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import bdcUserContext from "../../contextServices/bdcUserContext";
import {
  isLoggedIn as isLoggedInDE,
  login as loginDE,
} from "../../../utils/DeApi";
import moment from "moment";

/**
 * Handles logging in to the application.
 * Handles single sign on.
 */
class Login extends Component {
  static contextType = bdcUserContext;

  constructor(props) {
    super(props);

    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleEmailChange = this._handleEmailChange.bind(this);
    this.handlePasswordChange = this._handlePasswordChange.bind(this);
    this.check_BDC_Subscriber = this.check_BDC_Subscriber.bind(this);
    this.check_client_login = this.check_client_login.bind(this);
    this.check_PGM_Subscriber = this.check_PGM_Subscriber.bind(this);

    const loggedIn = isLoggedIn() && isLoggedInDE();
    let email = loggedIn ? loggedIn.email : "";
    let pattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    this.subscribedPromises = [];

    this.state = {
      email: email,
      password: "",
      emailValid: pattern.test(email),
      passwordValid: false,
      error: "",
      loggedIn: loggedIn,
      formSubmitted: false,
      bdcLoggedin: false,
      clientLoggedIn: false,
    };
  }

  componentWillUnmount() {
    // this.subscribedPromises.forEach(function (promise) {
    //   promise.cancel();
    // });
  }

  _handleEmailChange(event) {
    let email = event.target.value;
    let pattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    this.setState({ email: email, emailValid: pattern.test(email) });
  }
  _handlePasswordChange(event) {
    let password = event.target.value;
    this.setState({
      password: password,
      passwordValid: password.length ? true : false,
    });
  }
  _handleSubmit(event) {
    event.preventDefault();
    this.setState({ formSubmitted: true }, (state, props) => {
      if (this.state.emailValid && this.state.passwordValid) {
        this.setState({ error: "", isLoading: true });
        login({ email: this.state.email, password: this.state.password })
          .then((data) => {
            return loginDE();
          })
          .then((data) => {
            this.check_BDC_Subscriber(this.state.email);
            this.check_client_login(this.state.email);
            localStorage.setItem("filedAt", moment().format("YYYY-MM-DD"));
          })
          .catch((error) => {
            this.setState({ error: error, isLoading: false });
          });
      }
    });
  }

  check_BDC_Subscriber(email) {
    const { senseBDCUSer, unSenseBDCUser } = this.context;
    const bdcUserCheckPromise = get("/check-bdc-subscriber", {
      params: { email },
      timeout: 10000,
    });
    Promise.resolve(bdcUserCheckPromise.promise)
      .then((response) => {
        if (response.count > 0) {
          setToken("is_bdc_loggedIn", "y");
          this.setState({ bdcLoggedin: true });
          senseBDCUSer();
        } else {
          setToken("is_bdc_loggedIn", "n");
          this.setState({ bdcLoggedin: false });
          unSenseBDCUser();
        }
        this.setState({ loggedIn: true, isLoading: false });
      })
      .catch((error) => {
        console.log(
          "Error occured while fetching bdc user status api call: ",
          error
        );
      });

    this.subscribedPromises.push(bdcUserCheckPromise);
  }

  check_PGM_Subscriber(email) {
    const { sensePGMUser, unSensePGMUser } = this.context;
    const PgmUserCheckPromise = get("/check-pmg-subscriber", {
      params: { email },
      timeout: 10000,
    });
    Promise.resolve(PgmUserCheckPromise.promise)
      .then((response) => {
        if (response.count > 0) {
          setToken("is_pgm_loggedIn", "n");
          setToken("is_pgm_user", "y");
          this.setState({ pgmLoggedin: false });
          unSensePGMUser();
        } else {
          setToken("is_pgm_loggedIn", "n");
          setToken("is_pgm_user", "n");
          this.setState({ pgmLoggedin: false });
          unSensePGMUser();
        }
        this.setState({ loggedIn: true, isLoading: false });
      })
      .catch((error) => {
        console.log(
          "Error occured while fetching bdc user status api call: ",
          error
        );
      });

    this.subscribedPromises.push(PgmUserCheckPromise);
  }

  check_client_login(email) {
    const { senseClient, unSenseClient } = this.context;
    const clientLoginPromise = get("/check-client-login", {
      params: { email },
    });
    clientLoginPromise.promise
      .then((response) => {
        if (response.count > 0) {
          setToken("is_client_loggedIn", "y");
          this.setState({ clientLoggedIn: true });
          senseClient();
        } else {
          setToken("is_client_loggedIn", "n");
          this.setState({ clientLoggedIn: false });
          unSenseClient();
        }
        this.setState({ loggedIn: true, isLoading: false });
      })
      .catch((error) => {
        console.log("Error occured while checking client login api: ", error);
      });

    this.subscribedPromises.push(clientLoginPromise);
  }

  renderLoginForm() {
    const { email, emailValid, password, passwordValid, error, formSubmitted } =
      this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="text-center">
          <h2>Login to continue</h2>
        </div>
        <hr />
        <Form.Group>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={this.handleEmailChange}
            isValid={!emailValid && formSubmitted}
            placeholder="Enter email"
            autoFocus
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={this.handlePasswordChange}
            isValid={!passwordValid && formSubmitted}
            autoComplete="on"
            placeholder="Password"
          />
        </Form.Group>

        {error && <ErrorHandler error={error} />}
        <Button type="submit" color="primary" size="lg" block>
          Login
        </Button>
        <p className="text-muted text-center pt-3 pb-1">
          <small>
            By continuing, you agree to our <a href="/#">Terms of Service</a>{" "}
            and have read and acknowledge our <a href="/#">Privacy Statement</a>
            .
          </small>
        </p>
        <hr />
        <p className="text-center">
          <Link to="/login-help">Forgot Password?</Link>
        </p>
      </Form>
    );
  }

  render() {
    const { loggedIn, isLoading } = this.state;

    if (loggedIn) {
      let { from } = this.props.location.state || {
        from: { pathname: "/" },
      };
      return <Redirect to={from} />;
    }

    if (isLoading) return <Loader />;

    return (
      <Container fluid className="mt-5">
        <Row>
          <Col
            lg={{ span: 4, offset: 4 }}
            md={{ span: 6, offset: 3 }}
            sm={{ span: 8, offset: 2 }}
          >
            <div className="text-center mt-3 mb-3">
              <h1>DealSense</h1>
            </div>
            <Card className="mt-2">
              <Card.Body>{this.renderLoginForm()}</Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Login;
